module.exports = "<div class=\"c-text ql-editor\" ng-bind-html=\"vm.content\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/content-types/text/text.html
// module id = 435
// module chunks = 0